/*! scrollStop.js | (c) 2017 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/scrollStop */
/**
 * Run functions after scrolling has stopped
 * @param  {Function} callback The function to run after scrolling
 */

var scrollStop = function(callback) {
  // Make sure a valid callback was provided
  if (
    !callback ||
    Object.prototype.toString.call(callback) !== '[object Function]'
  ) {
    return
  }

  // Setup scrolling variable
  var isScrolling

  var handleScroll = function(event) {
    // Clear our timeout throughout the scroll
    window.clearTimeout(isScrolling)

    // Set a timeout to run after scrolling ends
    isScrolling = setTimeout(function() {
      // Run the callback
      callback()
    }, 200)
  }

  // Listen for scroll events
  window.addEventListener('scroll', handleScroll, false)

  return () => {
    window.clearTimeout(isScrolling)
    window.removeEventListener('scroll', handleScroll, false)
  }
}

export default scrollStop



// WEBPACK FOOTER //
// ./src/utils/scrollStop.js